<template>
  <v-form ref="loginForm" @submit.prevent="send">
    <v-card-text>
      <v-text-field
        v-model="credential.companyLogin"
        :label="$t('user.company')"
        :rules="[(v) => !!v || $t('error.form.required')]"
        prepend-icon="mdi-account"
        type="text"
      />
      <v-text-field
        v-model="credential.userLogin"
        :label="$t('user.login')"
        :rules="[(v) => !!v || $t('error.form.required')]"
        prepend-icon="mdi-account"
        type="text"
      />
      <v-text-field
        v-model="credential.password"
        :label="$t('user.password')"
        :rules="[(v) => !!v || $t('error.form.required')]"
        prepend-icon="mdi-lock"
        type="password"
      />
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        :loading="loading"
        :disabled="loading"
        color="accent"
        type="submit"
        v-text="$t('general.connect')"
      />
      <v-spacer />
    </v-card-actions>
  </v-form>
</template>

<script>
export default {
  name: 'LoginForm',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    credential: {
      companyLogin: '',
      userLogin: '',
      password: '',
    },
  }),
  methods: {
    send () {
      if (this.$refs.loginForm.validate()) {
        this.$emit('send', this.credential)
      }
    },
  },
}
</script>
